import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { getConditionValue } from '@components/ui/pipe/val-condition-pipe';
import { UiModule } from '@components/ui/ui-module';
import { CardCondition } from '@models/binder.model';
import { MarketPlace } from '@models/card.model';
import { Global } from '@services/global.service';
import { PARAM_DEFAULT_CONDITION, PARAM_DEFAULT_MARKET, ParamApiQuery, ParamUser, User } from '@services/user.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lgb-user-options',
  imports: [
    FormsModule,
    UiModule
  ],
  templateUrl: './user-options.html',
  styleUrl: './user-options.css',
})
export class UserOptions {
  //services
  readonly global=inject(Global);
  readonly userS=inject(User);

  //data
  readonly markets=signal<MarketPlace[]>([]);
  readonly conditions=signal<CardCondition[]>([]);
  readonly uParam=signal<ParamUser[]>([]);
  params=signal<ParamApiQuery>({market: null, scanCondition: null});

  //ui
  readonly loading=signal(false);

  constructor(){
    this.loading.set(true);
    forkJoin({
      init: this.global.init(),
      params: this.userS.getMyParams()
    }).subscribe(result => {      
      //init data
      const markets: MarketPlace[]=result.init.marketplaces
        .filter((m: MarketPlace) => m.type=='market' && m.display)
        .sort((a: MarketPlace, b: MarketPlace) => a.index-b.index);
      this.markets.set(markets);
      this.conditions.set(result.init.conditions.sort((a: CardCondition, b: CardCondition) => getConditionValue(b.ref)-getConditionValue(a.ref)));

      //init params
      this.initParams(result.params);

      this.loading.set(false);
    });
  }

  initParams(params: ParamUser[]){
    const setting={
      market: 'lgb',
      scanCondition: 'NM'
    };

    //set market
    const market=params.find(p => p.name==PARAM_DEFAULT_MARKET);
    if(market)
      setting.market=market.value;

    //set condition
    const condition=params.find(p => p.name==PARAM_DEFAULT_CONDITION);
    if(condition)
      setting.scanCondition=condition.value;

    this.params.set(setting);
  }

  setParams(){
    this.loading.set(true);
    this.userS.setMyParams(this.params())
      .subscribe(() => this.loading.set(false));
  }

}
